import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteFooter from '../components/Footer';
import GoogleSignInButton from '../components/GoogleSignInButton';
import API_BASE_URL from '../utils/config';
import '../App.css';

const EmailIcon = () => (
  <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
    <path d="M10 14a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V14zm2 0l8 6 8-6" stroke="#555" strokeWidth="2" strokeLinejoin="round" fill="none"/>
  </svg>
);

declare global {
  interface Window {
    google: any;
  }
}

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const form = new URLSearchParams();
      form.append('username', email);
      form.append('password', password);
      form.append('org', 'neutralfit');
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: form.toString(),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        navigate('/club-fitting');
      } else {
        setError('Login failed.');
      }
    } catch (err) {
      setError('Login failed.');
    }
  };

  const handleGoogleSuccess = async (response: any) => {
    setError('');
    try {
      const backendResponse = await fetch(`${API_BASE_URL}/neutralfit/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          credential: response.credential,
          clientId: '438852602805-agl6s3uvm50ps5kgbv124dlkovmv9191.apps.googleusercontent.com'
        })
      });

      if (!backendResponse.ok) {
        throw new Error(`Backend authentication failed: ${backendResponse.status}`);
      }

      const backendData = await backendResponse.json();
      
      localStorage.setItem('user', JSON.stringify(backendData.user));
      localStorage.setItem('token', backendData.access_token);
      
      navigate('/club-fitting');
      
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown authentication error';
      setError(`Google authentication failed: ${errorMessage}`);
    }
  };

  const handleGoogleError = (error: string) => {
    setError(`Google Sign-In error: ${error}`);
  };

  return (
    <div className="nf-form-container">
      <button className="nf-home-btn" type="button" onClick={() => navigate('/')} aria-label="Close">&#10005;</button>
      <h2 className="nf-form-title">Login</h2>
      
      {/* 1. Login Button (Form) - First */}
      <form className="nf-form" onSubmit={handleSubmit}>
        <input className="nf-input" name="email" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required />
        <input className="nf-input" name="password" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required />
        <button className="nf-btn nf-btn-primary nf-form-btn" type="submit">Login</button>
      </form>
      
      {/* Error message right after Login button */}
      {error && <div className="nf-error" style={{ marginTop: '1rem' }}>{error}</div>}
      
      {/* Divider */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        margin: '1.5rem 0',
        textAlign: 'center'
      }}>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
        <span style={{ 
          padding: '0 1rem', 
          color: '#666', 
          fontSize: '0.9rem',
          backgroundColor: 'white'
        }}>
          or
        </span>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
      </div>
      
      {/* 2. Google Sign-In Button - Second */}
      <div style={{ marginBottom: '1.5rem', width: '100%' }}>
        <GoogleSignInButton 
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
        />
      </div>
    
      {/* 3. Sign in with email button - Third */}
      <div style={{ marginBottom: '1.5rem', width: '100%' }}>
        <button
          className="nf-btn nf-btn-secondary nf-form-btn"
          style={{ 
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            minWidth: 'unset',
            maxWidth: 'none',
            height: '40px',
            padding: '8px 16px'
          }}
          onClick={() => {
            // Navigate to signup page
            navigate('/signup');
          }}
        >
          <span style={{ marginRight: '1.0rem' }}>
            <EmailIcon />
          </span>
          Sign in with email
        </button>
      </div>
      
      <div className="nf-info-section">
        Forgot your password? Click <Link to="/forgot-password" className="nf-link nf-forgot-link">Reset Password</Link>
      </div>

      <SiteFooter style={{ marginTop: '30px' }} />
    </div>
  );
};

export default Login;
